import Vue from 'vue'
import { Message } from 'element-ui';

import { Base64 } from "js-base64"
import { parseTime } from "./index"
function Base64Decode(str) {
    return Base64.decode(str);
}

Vue.filter('Base64Decode', Base64Decode) //base64解码
Vue.prototype.$Base64Decode = Base64Decode;

Vue.prototype.$getFinalDayTime = function (year, month) {
    if (month != 12)
        return new Date(
            new Date(`${year}-${month + 1}-01 00:00:00`) - 1000
        ).format("yyyy-MM-dd hh:mm:ss");
    return new Date(
        new Date(`${year + 1}-01-01 00:00:00`) - 1000
    ).format("yyyy-MM-dd hh:mm:ss");
};

Vue.prototype.$suc = function (msg) {
    Message({
        message: msg,
        type: 'success'
    });
}
Vue.prototype.$err = function (msg) {
    Message.error(msg);
}

Vue.prototype.$confirm = function (msg) {
    return new Promise((resolve, reject) => {
        this.$confirm(msg, { title: "询问" }).then(res => {
            resolve();
            done()
        }).catch(err => {
            reject(err)
        });
    })
}
Vue.prototype.$parseTime = parseTime

// new Date().format("yyyy-MM-dd HH:mm:ss")
Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}
